import { render, staticRenderFns } from "./gradeTestRecord.vue?vue&type=template&id=b14b8b14&scoped=true"
import script from "./gradeTestRecord.vue?vue&type=script&lang=js"
export * from "./gradeTestRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b14b8b14",
  null
  
)

export default component.exports